<template>
    <div>
        <div class="flex flex-col justify-center">
            <div class=" p-2 border-t bg-white overflow-auto p-4 rounded shadow">
                <div class="font-semibold mb-2 text-gray-600">Add new row</div>
                <div>
                    <p>
                        Row can have more than one dashboards and an be swapped up and down
                    </p>
                </div>
                <select-dashboard :layout="selectedLayout" v-if="selectedLayout"></select-dashboard>
                <div class="" v-else>
                    <p>Select dashboard layout</p>
                    <div :key="index" v-for="(layout, index) in layouts" class="flex mb-4 mt-3"
                    v-on:click="selectedLayout = layout">
                        <div :key="index" v-for="(card, index) in layout" :class="'w-'+card"
                             class="p-2 m-2 bg-gray-400 text-center">{{card}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
    import SelectDashboard from "./SelectDashboard";
    

    export default {
        name: "AddDashletComponent",
        components: {SelectDashboard},
        data() {
            return {
                layouts: {
                    full: ["full"],
                    half: ["1/2", "1/2"],
                    half_2_quaters: ["1/4", "1/4", "1/2"],
                    four_quater: ["1/4", "1/4", "1/4", "1/4"],
                    quater_3_quater: ["1/4", "3/4"],
                    a_third_2_thirds: ["1/3", "2/3"],
                    three_thirds: ["1/3", "1/3", "1/3"]
                },
                selectedLayout: null
            }
        },
        mounted() {
            this.$root.$on("add_dashlet", () => {
                this.selectedLayout = null;
            });
            this.selectedLayout = null;
        }
    }
</script>

<style scoped>

</style>